// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"b073fcc6bbb68bbf2138","303":"6d6ea785e724b9be128a","495":"fe5a9443cfb7af5199d0"}[chunkId] + ".js";
};